// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__2x_f6","pageInput":"Pagination_pageInput__f5Wib"};